import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './Dashboard';
import Orders from './Orders';
import Refunds from './Refunds';
import Products from './Products';
import Categories from './Categories';
import Communities from './Communities';
import BulkProductReview from './BulkProductReview';
import Banners from './Banners';
import Notifications from './Notifications';
import Announcements from './Announcements';
import Support from './Support';
import Transactions from './Transactions';
import Reports from './Reports';
import Customers from './Customers';
import Sellers from './Sellers';
import Subscribers from './Subscribers';
import CustomerProfile from './CustomerProfile';
import SellerProfile from './SellerProfile';
import SubscriberProfile from './SubscriberProfile';
import Employees from './Employees';
import UserProfile from './UserProfile';
import Settings from './Settings';
import ActivityLogs from './ActivityLogs';
import Permissions from './Permissions';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import SignIn from './SignIn';
import { AuthProvider } from '../AuthContext';
import PrivateRoute from '../PrivateRoute';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };


  return (
    <AuthProvider>
      <Router>
        <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} newestOnTop closeOnClick pauseOnFocusLoss draggable pauseOnHover />
        <Routes>
          <Route path="/signin" element={<SignIn />} />
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <div className="ec-header-fixed ec-sidebar-fixed ec-sidebar-light" id="body">
                  <Sidebar isOpen={isSidebarOpen} />
                  
                  <div className="ec-page-wrapper">
                      <Navbar toggleSidebar={toggleSidebar} />
                      <Routes>
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/transactions" element={<Transactions />} />
                        <Route path="/orders" element={<Orders />} />
                        <Route path="/refunds" element={<Refunds />} />
                        <Route path="/products" element={<Products />} />
                        <Route path="/categories" element={<Categories />} />
                        <Route path="/communities" element={<Communities />} />
                        <Route path="/bulk-product-review" element={<BulkProductReview />} />
                        <Route path="/banners" element={<Banners />} />
                        <Route path="/notifications" element={<Notifications />} />
                        <Route path="/announcements" element={<Announcements />} />
                        <Route path="/support" element={<Support />} />
                        <Route path="/reports" element={<Reports />} />
                        <Route path="/customers" element={<Customers />} />
                         <Route path="/customers/:id" element={<CustomerProfile />} />
                        <Route path="/sellers" element={<Sellers />} />
                         <Route path="/sellers/:id" element={<SellerProfile />} />
                        <Route path="/subscribers" element={<Subscribers />} />
                         <Route path="/subscribers/:id" element={<SubscriberProfile />} />
                        <Route path="/employees" element={<Employees />} />
                         <Route path="/employees/:id" element={<UserProfile />} />
                        <Route path="/permissions" element={<Permissions />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/activity-logs" element={<ActivityLogs />} />
                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                      </Routes>
                  </div>
                </div>
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
